import { Badge } from '@monksflow/monks-ui';
import type { WorkspaceResponseDto } from '@monksflow/platform-api-sdk';
import { useTranslation } from 'react-i18next';

import { WorkspaceChipList } from './WorkspaceChipList';

const EM_DASH = '—';

interface ToolConfigurationCellProps {
  hasConfigurable: boolean;
  allHaveOrgConfig: boolean;
  fullyConfiguredWorkspaces: WorkspaceResponseDto[];
  unconfiguredCount: number;
}

/** The four states are exclusive and ordered: nothing to do, done, partly done, outstanding. */
export function ToolConfigurationCell({
  hasConfigurable,
  allHaveOrgConfig,
  fullyConfiguredWorkspaces,
  unconfiguredCount,
}: ToolConfigurationCellProps) {
  const { t } = useTranslation('admin');

  if (!hasConfigurable) {
    return <span className="text-body-sm text-muted-foreground">{EM_DASH}</span>;
  }

  if (allHaveOrgConfig) {
    return (
      <Badge variant="positive" size="sm" roundness="full">
        {t('admin.toolsTable.configured')}
      </Badge>
    );
  }

  if (fullyConfiguredWorkspaces.length > 0) {
    return <WorkspaceChipList workspaces={fullyConfiguredWorkspaces} variant="positive" />;
  }

  return (
    <Badge variant="destructive" size="sm" roundness="full">
      {t('admin.toolsTable.toolsUnconfigured', { count: unconfiguredCount })}
    </Badge>
  );
}
